import React, { useRef, useEffect } from 'react';
import { shared } from '../../config';

export const TrustPilotCarousel = () => {
  const ref = useRef();
  const trustPilotUri = `https://www.trustpilot.com/review/www.${shared.SITE_NAME}`;

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    window.Trustpilot?.loadFromElement(ref.current, true);
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="54ad5defc6454f065c28af8b"
      data-businessunit-id="69733e383abac9f2c112e05b"
      data-style-height="240px"
      data-style-width="100%"
      data-theme="light"
      data-stars="4,5"
      data-review-languages="en"
    >
      <a href={trustPilotUri} target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};

TrustPilotCarousel.displayName = 'TrustPilotCarousel';
